<template>
  <div class="animated fadeIn all-banners">
    <div v-if="!loaded" class="d-flex flex-column align-items-center mt-8 py-6">
      <atom-spinner :animation-duration="1000" :size="80" :color="'#EF6C00'" />
      <p class="primary--text font-weight-bold mt-4">
        در حال بارگذاری اطلاعات...
      </p>
    </div>
    <div v-else>
      <v-card class="common-card" style="height: 100% !important">
        <div class="d-flex flex-column ">
          <div><h4 class="c-grey">مدیریت بنرها</h4></div>

          <v-divider
     
          ></v-divider>

        
        </div>
        <v-row>
          <v-col class="pb-0">
            <h4 class="fs-xlarge c-dark ms-4">گالری بنر‌ها</h4>
          </v-col>
          <v-col cols="5" class="text-left">
            <v-btn
              height="48"
              class="orange-borderedBtn"
              @click="openBannerDialog()"
              ><v-icon class="orange-icon me-1"> mdi-plus-box-multiple </v-icon>
              افزودن بنر
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="mt-0 flex-column">
         
          
            <div
              class="px-lg-4 px-0"
              v-for="(item, index) in banners"
              :key="index"
            >
              <div class="image-box">
                <v-img :src="item.image" :aspect-ratio="16 / 9"></v-img>
                <div
                  class="image-title fs-medium d-flex flex-row"
                  style="z-index: 5"
                >
                  <div>
                    {{
                      item.name.length > 25
                        ? item.name.slice(0, 25) + "..."
                        : item.name
                    }}
                  </div>
                  <div class="hover-box d-sm-none" @click="showBig(item)" >
                        <div class="d-flex flex-row">
                          <v-icon class="shopPrimary--text">mdi-magnify</v-icon>
                          <p class="fs-large mb-0 shopPrimary--text ms-1">مشاهده</p>
                        </div>
                      </div>
                  <v-spacer></v-spacer>
                  <div @click="openModal(item, 'edit'); selectedIndex=index"  class="pe-5">
                    <v-icon
                      class="img-icons shopPrimary--text pointer"
                      style="transform: translateY(-1px)"
                      >mdi-pencil-box-outline</v-icon
                    >
                  </div>
                  <div @click="openModal(item, 'delete')">
                    <v-icon class="img-icons shopPrimary--text pointer"
                      >mdi-trash-can</v-icon
                    >
                  </div>
                </div>
              
              </div>
            </div>
       
        </v-row>
      </v-card>
     
      <v-dialog v-model="editBannerDialog" width="400">
        <v-card>
          <v-card-title class="white"
            ><v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                  ویرایش بنر
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="cancelEditBanner()"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mt-0 pt-0" />
          <v-card-text class="pa-3">
            <v-text-field
              v-model="selectedImage.name"
              outlined
              dense
              placeholder="عنوان بنر"
            >
            </v-text-field>
            <v-text-field
              v-model="selectedImage.link"
              outlined
             dense
              placeholder="لینک بنر"
            >
            </v-text-field>
            <div class="text-left pe-3 pb-4 pt-0">
              <v-btn
                class="green-mainBtn me-3"
                @click="editBanner()"
                :disabled="!selectedImage.name"
              >
                تایید
              </v-btn>
              <v-btn class="red-mainBtn" @click="cancelEditBanner()">
                بستن
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteBannerDialog" width="400">
        <v-card class="modal-card">
          
            <v-card-title class="white"
            ><v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                 حذف بنر
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="cancelDeleteBanner()"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row></v-card-title
          >
          <hr class="mt-0 pt-0" />
            <div class="pe-3 ps-3">
              <span class="mainFont--text"
                >آیا از حذف بنر اطمینان دارید؟</span
              >
            </div>
            <div class="text-left pe-3 pb-4 pt-0">
              <v-btn
                class="green-mainBtn me-3"
                @click="deleteBanner()"
              >
                تایید
              </v-btn>
              <v-btn class="red-mainBtn" @click="cancelDeleteBanner()">
                بستن
              </v-btn>
            </div>
      
        </v-card>
      </v-dialog>
      <v-dialog v-model="openNewBannerDialog" width="400">
        <v-card>
          <v-card-title class="white"
            ><v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                  افزودن بنر جدید
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="cancelNewBanner()"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row></v-card-title
          >
          <hr class="mt-0 pt-0" />

          <v-card-text class="pa-3">
            <v-row>
              <v-col md="6" cols="12" class="pt-0">
                <div
                  class="img-box pointer"
                  @click="$refs.bannerImage.$refs.input.click()"
                >
                  <img
                    height="150"
                    width="150"
                    class="img"
                    :src="
                      newBanner.image
                        ? newBanner.image
                        : '/no-image.png'
                    "
                  />
                  <v-icon x-large class="img-icon white--text"
                    >mdi-camera</v-icon
                  >
                  <div class="img-loading" v-if="bannerImageLoading">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      :size="40"
                    ></v-progress-circular>
                    <h6 class="mt-4 grey--text text--darken-4">
                      در حال بارگذاری...
                    </h6>
                  </div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="mt-16">
                  <v-btn
                    class="orange-borderedBtn pa-5 mt-8"
                    style="width: 100%"
                    @click="$refs.bannerImage.$refs.input.click()"
                  >
                    <v-icon class="me-2">mdi-camera-outline</v-icon> بارگذاری
                    تصویر بنر</v-btn
                  >
                  <v-file-input
                    v-show="false"
                    @change="newBannerImageUpload(bannerImage)"
                    v-model="bannerImage"
                    ref="bannerImage"
                  ></v-file-input>
                </div>
              </v-col>
            </v-row>
            <v-text-field
              v-model="newBanner.name"
              outlined
              dense
              label="نام بنر"
            >
            </v-text-field>

            <v-text-field
              v-model="newBanner.link"
              outlined
              dense
              label="لینک متصل به بنر"
            >
            </v-text-field>

            <div class="text-left pe-3 pb-4 pt-0">
              <v-btn
                class="green-mainBtn me-3"
                :disabled="!newBanner.image || !newBanner.name"
                @click="addBanner()"
              >
                تایید
              </v-btn>
              <v-btn class="red-mainBtn" @click="cancelNewBanner()">
                بستن
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showImage" width="400">
        <v-card class="modal-card" >
          <v-container class="text-center">
            <div class="image-box">
              <img :src="selected.image" />
            </div>
            <div class="px-1 mt-4 fs-medium text-right">
              {{ selected.name }}
            </div>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import { AtomSpinner } from "epic-spinners";
export default {
  components: {
    AtomSpinner,
  },
  data() {
    return {
      showImage:false,
      loaded: false,
      selectedIndex:'',
      newBanner: {},
      uploadedFiles: [],
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      banners: [],
      editedBanners:[],
      loaded: false,
      filter: "",
      selected: {},
      showImage: false,
      // vLoading: false,
      editBannerDialog: false,
      deleteBannerDialog: false,
      openNewBannerDialog: false,
      selectedImage: {},
      deviceType: "",
      role: "",
      uploading: false,
      title: "",
      link: "",
      bannerImage: {},
      editBannerImage: [],
      editBannerImageLoading: false,
      bannerImageLoading: false,
      editMyBannerImage: new Object({
        uploadPercentage: 0,
      }),
      myBannerImage: new Object({
        uploadPercentage: 0,
      }),
    };
  },
  methods: {
    showBig(item) {
      this.selected = item;
      this.showImage = true;
    },
    openModal(item, type) {
      this.selectedImage = JSON.parse(JSON.stringify(item));
      if (type == "edit") {
        this.editBannerDialog = true;
      }
      if (type == "delete") {
        this.deleteBannerDialog = true;
      }
    },
    // deleteImage() {
    //   this.vLoading = true;
    //   this.$http
    //     .post(
    //       this.baseUrl + "/setad/" + this.role + "/profile/removeGallery",
    //       {
    //         fileId: this.selectedImage.id,
    //       },
    //       {
    //         headers: {
    //           Authorization: "Bearer: " + localStorage.getItem("userId"),
    //         },
    //       }
    //     )
    //     .then((res) => {
    //       this.deleteBannerDialog = false;
    //       this.toast(res.data, "success");
    //       this.getbanners();
    //     })
    //     .catch((err) => {
    //       this.vLoading = false;
    //       if (err.response.status == 403)
    //         // this.$router.replace("/unauthorize");
    //         this.$router.push({
    //           path: "/login",
    //           query: { return: window.location.pathname },
    //         });
    //     });
    // },

    getBanners() {
      Axios.get(this.baseUrl + "/onlineShop/options/banners", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
           this.loaded = true;
            this.banners = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.toast(title, "error");
            this.loaded = true;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loaded = true;
        });
    },

   
    openBannerDialog() {
      this.openNewBannerDialog = true;
      this.newBanner = {};
    },
    cancelNewBanner() {
      this.openNewBannerDialog = false;
      this.newBanner = {};
      this.bannerImage = {};
      this.myBannerImage = new Object({
        uploadPercentage: 0,
      });
    },
    cancelDeleteBanner(){
      this.deleteBannerDialog=false;
      this.selectedIndex="";
      this.selectedImage={};
    },
    cancelEditBanner(){
      this.editBannerDialog = false;
      this.selectedIndex="";
      this.selectedImage={};
    },
    newBannerImageUpload(file) {
      if (!file) {
        return;
      }
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
        return;
      } else {
        // NOTE (m-myUpload) to upload files
        this.myBannerImage.showProgress = true;
        this.myBannerImage.variant = "info";
        this.myBannerImage.uploadPercentage = 0;
        this.myBannerImage.isUploaded = false;
        this.myBannerImage.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.bannerImageLoading = true;
        Axios.post(this.baseUrl + "/satrapp/option/upload/banner", formData, {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
          onUploadProgress: ((progressEvent) => {
            this.myBannerImage.uploadPercentage =
              Math.round((progressEvent.loaded * 100) / progressEvent.total) -
              1;
          }).bind(this),
        })
          .then((d) => {
            if (d.status == 200) {
              this.toast(d.data.message, "success");
              this.bannerImageLoading = false;
              this.myBannerImage.isUploaded = true;
              this.myBannerImage.uploadPercentage = 100;
              this.myBannerImage.striped = false;
              this.myBannerImage.variant = "success";
              this.myBannerImage.uploadButDisable = false;
              // this.newBanner.pictureId = d.data.id;
              this.newBanner.image = d.data.url;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.bannerImageLoading = false;
          });
      }
    },
    addBanner() {
      this.banners.push(this.newBanner);
      Axios.patch(
        this.baseUrl + "/satrapp/option/banners/edit",

        {
          value: this.banners,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.getBanners();
            this.toast(res.data.message, "success");
            this.newBanner = {};
            this.openNewBannerDialog = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.openNewBannerDialog = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.openNewBannerDialog = false;
        });
    },
    editBanner() {
      this.banners[this.selectedIndex]=this.selectedImage;
      Axios.patch(
        this.baseUrl + "/satrapp/option/banners/edit",
        {
          value: this.banners,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.getBanners();
            this.toast(res.data, "success");
            this.editBannerDialog = false;
            this.selectedImage = {};
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.editBannerDialog = false;
            this.selectedImage = {};
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.editBannerDialog = false;
          this.selectedImage = {};
        });
    },
    deleteBanner() {
      this.banners.splice(this.selectedIndex,1);
      Axios.patch(
        this.baseUrl + "/satrapp/option/banners/edit",
        {
          value: this.banners,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.getBanners();
            this.toast(res.data, "success");
            this.deleteBannerDialog = false;
            this.selectedImage = {};
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.deleteBannerDialog = false;
            this.selectedImage = {};
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.deleteBannerDialog = false;
          this.selectedImage = {};
        });
    },
  },
  mounted() {
    this.getBanners();
    if (window.screen.width < 850) {
      this.deviceType = "mobile";
    } else {
      if (document.body.clientWidth < 850) {
        this.deviceType = "mobile";
      } else {
        this.deviceType = "desktop";
      }
    }
  },
};
</script>
<style lang="scss">
.modal-card {
  border-radius: 10px !important;
  img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .textField-box {
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #ef6c00 !important;
    }
    .v-input__slot {
      min-height: 48px !important;
      margin-bottom: 25px;
      input {
        color: #656a81 !important;
      }
      .v-text-field__suffix {
        color: #656a81 !important;
      }
    }
  }
  .gallery-imageBox {
    img {
      width: 300px;
      height: 100%;
    }
  }
  .textField-box2 {
    .v-text-field__details {
      display: none;
    }
    .v-input__slot {
      min-height: 30px !important;
      margin-bottom: 15px;
      input {
        color: #656a81 !important;
      }
      .v-text-field__suffix {
        color: #656a81 !important;
      }
    }
  }
}
.image-box {
  margin: 20px auto;
  height: 260px;
  width:100%;
  position:center!important;
  background-size: cover !important;
  // cursor: pointer;
  position: relative !important;
  .image-title {
    width: 100%;
    text-align: right;
    color: #fff;
    padding: 13px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .v-image {
    width: 100%;
    height: 100%;
  }
  .hover-box {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 90;
    width: 100%;
    height: 100%;
    display: none;
    color: #fff !important;
    path,
    circle {
      stroke: #fff !important;
    }
    div {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding: 20px;
      background-color: rgba(0, 0, 0, 0.6);
      border-radius: 7px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  &:hover {
    .hover-box {
      display: block;
    }
  }
}
</style>
